import React from 'react';
// General Utils
import { theme } from 'theme';

// Material Core and Icons
import { styled } from '@material-ui/core/styles';
import { Stack, Typography, useTheme, Grid } from '@mui/material';
import { RedLinkButton } from 'pages/ticketV2/common';

import {
  ModeEditOutlineOutlined,
  DeleteOutlineOutlined,
  ConfirmationNumberOutlined,
} from '@mui/icons-material';
import { useTicketsStore } from 'pages/ticketV2/store/ticketsStore';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { isDiscountTicket } from 'utils/constants';

const Card = styled('div')(({ isSmDown }) => ({
  padding: isSmDown ? 16 : 20,
  width: '100%',
  minHeight: 100,
  marginBottom: 25,
  backgroundColor: theme.colors.primary.white,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
}));

const RecapCard = ({
  idx,
  onEdit,
  onDelete,
  product,
  assignData,
  isSmDown,
  isMdDown,
  isOperator,
}) => {
  const { loggedDataAtIndex, submittedDiscountCodesWithEmptySpaces } =
    useTicketsStore();
  const theme = useTheme();
  const intl = useIntl();
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18nRecap = translations.TicketsV2(intl).Recap;
  const i18nDiscount = translations.DiscountCode(intl);

  const TicketActions = () => (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={isMdDown ? 'space-between' : 'flex-end'}
      gap={'30px'}
    >
      <RedLinkButton
        onClick={onDelete}
        msg={i18nCommon.delete}
        icon={<DeleteOutlineOutlined color="primary" />}
      />
      <RedLinkButton
        onClick={onEdit}
        msg={i18nCommon.editRecap}
        icon={<ModeEditOutlineOutlined color="primary" />}
      />
    </Stack>
  );

  const isAccount = idx === loggedDataAtIndex;

  return (
    <Card isSmDown={isSmDown}>
      <Grid container>
        <Grid container item xs={12} alignItems="center" sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            {isAccount ? (
              <div
                style={{
                  backgroundColor: theme.palette.grey[200],
                  color: 'black',
                  borderRadius: '25px',
                  width: 'fit-content',
                  display: 'flex',
                  padding: '5px 10px',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <Typography
                  variant="xs-bold"
                  textAlign="center"
                  fontFamily={'Suisse-Intl'}
                >
                  {i18nCommon.accountOwner}
                </Typography>
              </div>
            ) : null}
          </Grid>
          {!isMdDown && (
            <Grid item xs={6}>
              <TicketActions />
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} md={5}>
          <Typography
            variant="m-bold"
            paragraph
            marginBottom={1.5}
            fontFamily={'Suisse-Intl'}
          >{`${assignData.firstname} ${assignData.lastname} `}</Typography>

          <Typography
            paragraph
            variant="link2"
            marginBottom={'16px !important'}
          >
            {isOperator ? i18nCommon.operator : i18nCommon.generalPublic}
          </Typography>
        </Grid>

        <Grid item xs={12} md={7}>
          <Grid container item marginBottom={'20px'}>
            <Grid item xs={12} md={4}>
              <Typography variant="link2" fontWeight="bold">
                {i18nRecap.tickets}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} alignItems="center">
              <Typography
                variant="link2"
                color={'#333333'}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <ConfirmationNumberOutlined
                  sx={{
                    color: theme.palette.grey[800],
                    mr: 0.6,
                  }}
                  fontSize="20px"
                />
                <span style={{ fontWeight: 600, marginRight: '5px' }}>1x</span>
                {` ${product.capacity} ${
                  i18nRecap[+product.capacity === 1 ? 'day' : 'days']
                }: ${assignData?.reservations
                  ?.filter((r) => !!r.selected)
                  .map((r) => r.date.split('-').at(-1))
                  .join('/')} ${i18nRecap.april}`}
              </Typography>
              {isDiscountTicket(product) ? (
                <Typography
                  variant="link2"
                  color="grey.800"
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  {i18nDiscount.Common.code}
                  <strong style={{ marginLeft: '4px' }}>
                    {' '}
                    {submittedDiscountCodesWithEmptySpaces[idx]}
                  </strong>
                </Typography>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>

        {isMdDown && (
          <Grid item xs={12} marginTop={2}>
            <TicketActions />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default RecapCard;
